import React from 'react'
import PropTypes from 'prop-types'
import { FormSectionContext } from 'src/contexts'
import { useFormSectionPath } from 'src/hooks'

export default function FormSection({ name, ...props }) {
  const parent = FormSectionContext.use()
  const path = useFormSectionPath(name)
  const disabled = parent.disabled || props.disabled
  const value = React.useMemo(() => ({ disabled, path }), [disabled, path])

  return <FormSectionContext.Provider value={value} {...props} />
}

FormSection.propTypes = {
  name: PropTypes.string,
  disabled: PropTypes.bool,
}
